import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import findFranquia from "../../service/findFranquia";
import findPlano from "../../service/findPlano";
import { SortOrder } from "primereact/api";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router";
import patchPlano from "../../service/patchPlano";
import restaurarPlano from "../../service/restaurarPlano";
import findClient from "../../service/findClient";
import getViaCep from "../../service/getViaCep";
import { maskCNPJ, isValidCNPJ, isValidCPF, isValidMultiEmail } from "../../utils/ValidationUtils";
import { Steps } from "primereact/steps";
import { MenuItem } from "primereact/menuitem";

export default function ClienteCadastrar({client, onClose, onSave, msgs}:{client:any, onClose: () => void, onSave: (user:any) => void, msgs:any}) {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [separarResposta, setSepararResposta] = useState(client.separarResposta ? client.separarResposta : false);
  const [limitarValorMaximo, setLimitarValorMaximo] = useState(client.limitarValorMaximo ? client.limitarValorMaximo : false);
  const [planos, setPlanos] = useState<any>([]);
  const [selectedFranquia, setSelectedFranquia] = useState<any>(null);
  const [franquias, setFranquias] = useState<any>([]);
  const {state} = useGlobalState();
  const [planoSelected, setPlanoSelected] = useState<any>(null);
  const navigate = useNavigate();
  const [clienteJaCadastrado, setClienteJaCadastrado] = useState(false);
  const [selectedSegmentoCnae, setSelectedSegmentoCnae] = useState(client.segmentoCnae || null);
  const [enviarParaQuod, setEnviarParaQuod] = useState(false);

  const itemRenderer = (item: MenuItem, itemIndex: number) => {
    const isActiveItem = activeIndex === itemIndex;
    const backgroundColor = isActiveItem ? '#183462' : 'var(--surface-b)';
    const textColor = isActiveItem ? '#4b5563' : 'var(--text-color-secondary)';

    return (
      <div className="flex-consulta flex-column align-items-center">
        <span
          className="inline-flex align-items-center justify-content-center border-circle border-primary border-1 h-3rem w-3rem z-1 cursor-pointer"
          style={{ backgroundColor: backgroundColor, color: isActiveItem ? 'white' : '#183462' }}
          onClick={() => setActiveIndex(itemIndex)}
        >
          <i className={`${item.icon} text-xl`} />
        </span>
        <span className="mt-2" style={{ fontSize: '1rem', color: textColor, fontWeight: isActiveItem ? '700' : 'normal' }}>
          {item.label}
        </span>
      </div>
    );
  };

  const items: MenuItem[] = [
    {
      label: 'Dados do cliente',
      icon: 'pi pi-user',
      template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Configurações',
      icon: 'pi pi-cog',
      template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Faturamento',
      icon: 'pi pi-money-bill',
      template: (item) => itemRenderer(item, 2)
    }
  ];

  const defaultValues = {
    nome: '',
    email: '',
    documento:'',
    responsavel: '',
    tempoCacheConsulta: null,
    telefone:'',
    plano: null,
    whatsapp:'',
    observacoes: '',
    codigoClienteErp: '',
    nomeFantasia: '',
    cep: '',
    logradouro: '',
    numeroEndereco: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    dataCadastro: client.dataCadastro ? new Date(client.dataCadastro) : null,
    dataContratacao: client.dataContratacao ? new Date(client.dataContratacao) : null,
    diaVencimentoFatura: '',
    vcm: null,
    valorMaximo: null,
    cnae: ''
  };
  defaultValues.nome = client.nome ? client.nome.toString() : ''
  defaultValues.email = client.email ? client.email.toString() : ''
  defaultValues.documento = client.documento ? client.documento.toString() : ''
  defaultValues.responsavel = client.responsavel ? client.responsavel.toString() : ''
  defaultValues.telefone = client.telefone ? client.telefone.toString() : ''
  defaultValues.whatsapp = client.whatsapp ? client.whatsapp.toString() : ''
  defaultValues.tempoCacheConsulta = client.tempoCacheConsulta ? client.tempoCacheConsulta : null
  defaultValues.observacoes = client.observacoes ? client.observacoes.toString() : ''
  defaultValues.codigoClienteErp = client.codigoClienteErp ? client.codigoClienteErp.toString() : ''
  defaultValues.nomeFantasia = client.nomeFantasia ? client.nomeFantasia.toString() : ''
  defaultValues.cep = client.cep ? client.cep.toString() : ''
  defaultValues.logradouro = client.logradouro ? client.logradouro.toString() : ''
  defaultValues.numeroEndereco = client.numeroEndereco ? client.numeroEndereco.toString() : ''
  defaultValues.complemento = client.complemento ? client.complemento.toString() : ''
  defaultValues.bairro = client.bairro ? client.bairro.toString() : ''
  defaultValues.cidade = client.cidade ? client.cidade.toString() : ''
  defaultValues.uf = client.uf ? client.uf.toString() : ''
  defaultValues.dataCadastro = client.dataCadastro ? new Date(client.dataCadastro) : null
  defaultValues.dataContratacao = client.dataContratacao ? new Date(client.dataContratacao) : null
  defaultValues.diaVencimentoFatura = client.diaVencimentoFatura ? client.diaVencimentoFatura.toString() : ''
  defaultValues.vcm = client.vcm ? client.vcm : 0.00
  defaultValues.valorMaximo = client.valorMaximo ? client.valorMaximo : 0.00
  defaultValues.cnae = client.cnae ? client.cnae.toString() : ''

const editarPlano = () => {
  navigate(`/plano/`,{state:{plano:planoSelected}});
}
const customizarPlano = () => {
  patchPlano(planoSelected.id, client.id)
  .then((data:any) => {
    data.planosServico.forEach((ps:any) => {
      ps.planosServicoValor.forEach((psv:any) => {
        psv.data = new Date(psv.data)
      });
    });
    navigate(`/plano/`,{state:{plano:data}});
  })
}
const restaurarPlanoCustomizado = () => {
  restaurarPlano(planoSelected.id, client.id, planoSelected.idOrigem)
  .then(() => {
    onClose();
  })
}


  const validDocument = (document:string) => {
    const valid = document.length === 14
      ? isValidCPF(document)
      : isValidCNPJ(document);
    if(valid){
      msgs.current?.clear();
      if (!client.id) {
        verificarClienteExistente(document.replace(/[^A-Z0-9]/gi, '').toUpperCase());
      }
    }
    else{
      msgs.current?.clear();
      msgs.current?.show([
         { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }

      ]);
    }
  }

  const {
      control,
      formState: { errors},
      handleSubmit,
      setValue,
      getValues
  } = useForm({ defaultValues });

  const segmentosCnae = [
    { name: 'Selecione', code: null },
    { name: 'Comércio', code: 'COMERCIO' },
    { name: 'Indústria', code: 'INDUSTRIA' },
    { name: 'Instituições Financeiras', code: 'INSTITUICOES_FINANCEIRAS' },
    { name: 'Outros', code: 'OUTROS' },
    { name: 'Serviços', code: 'SERVICOS' }
  ];

  const preencherDadosCliente = (clienteEncontrado: any) => {
    setValue('nome', clienteEncontrado.nome || '');
    setValue('email', clienteEncontrado.email || '');
    setValue('responsavel', clienteEncontrado.responsavel || '');
    setValue('telefone', clienteEncontrado.telefone ? clienteEncontrado.telefone.toString() : '');
    setValue('whatsapp', clienteEncontrado.whatsapp ? clienteEncontrado.whatsapp.toString() : '');
    setValue('observacoes', clienteEncontrado.observacoes || '');
    setValue('codigoClienteErp', clienteEncontrado.codigoClienteErp || '');
    setValue('nomeFantasia', clienteEncontrado.nomeFantasia || '');
    setValue('cep', clienteEncontrado.cep || '');
    setValue('logradouro', clienteEncontrado.logradouro || '');
    setValue('numeroEndereco', clienteEncontrado.numeroEndereco || '');
    setValue('complemento', clienteEncontrado.complemento || '');
    setValue('bairro', clienteEncontrado.bairro || '');
    setValue('cidade', clienteEncontrado.cidade || '');
    setValue('uf', clienteEncontrado.uf || '');
    setValue('cnae', clienteEncontrado.cnae || '');
    setSelectedSegmentoCnae(clienteEncontrado.segmentoCnae || null);
    setValue('vcm', clienteEncontrado.vcm || 0);
    setValue('valorMaximo', clienteEncontrado.valorMaximo || 0);
    setValue('diaVencimentoFatura', clienteEncontrado.diaVencimentoFatura || '');
    setValue('tempoCacheConsulta', clienteEncontrado.tempoCacheConsulta || null);
    if (clienteEncontrado.dataCadastro) setValue('dataCadastro', new Date(clienteEncontrado.dataCadastro));
    if (clienteEncontrado.dataContratacao) setValue('dataContratacao', new Date(clienteEncontrado.dataContratacao));

    setSepararResposta(clienteEncontrado.separarResposta || false);
    setLimitarValorMaximo(clienteEncontrado.limitarValorMaximo || false);

    if (clienteEncontrado.idPlano) {
      const plano = planos.find((p: any) => p.id === clienteEncontrado.idPlano || p.descricao === clienteEncontrado.nomePlano);
      if (plano) { setValue('plano', plano); setPlanoSelected(plano); }
    }
    if (clienteEncontrado.idFranquia) {
      const franquia = franquias.find((f: any) => f.id === clienteEncontrado.idFranquia || f.nome === clienteEncontrado.nomeFranquia);
      if (franquia) setSelectedFranquia(franquia);
    }
  }

  const verificarClienteExistente = (documento: string) => {
    findClient({
      first: 0,
      rows: 1,
      page: 1,
      cliente: null,
      documento: documento,
      codigoClienteErp: null,
      inativo: null,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: 'nome',
      sortOrder: SortOrder.DESC
    }).then((data) => {
      if (data.clientes && data.clientes.length > 0) {
        const clienteEncontrado = data.clientes[0];
        setClienteJaCadastrado(true);
        preencherDadosCliente(clienteEncontrado);
        msgs.current?.clear();
        msgs.current?.show([{
          sticky: true,
          severity: 'warn',
          summary: 'Cliente já cadastrado',
          detail: `O cliente "${clienteEncontrado.nome}" já está cadastrado com este documento. Não é possível prosseguir com o cadastro.`,
          closable: true
        }]);
      } else {
        setClienteJaCadastrado(false);
      }
    }).catch(() => {
      setClienteJaCadastrado(false);
    });
  }

  const onSubmit = (data:any) => {
      data.nome && save(data);
  };


  const save = (data:any) => {
    const cliente = {
      id: client.id? client.id : undefined,
      nome:data.nome,
      documento:data.documento.replace(/[^A-Z0-9]/gi, '').toUpperCase(),
      email:data.email,
      responsavel:data.responsavel,
      telefone:data.telefone,
      whatsapp:data.whatsapp,
      observacoes: data.observacoes,
      separarResposta:separarResposta,
      idPlano: data.plano ? data.plano.id : null,
      codigoClienteErp:data.codigoClienteErp,
      nomeFantasia:data.nomeFantasia,
      cep:data.cep,
      tempoCacheConsulta: data.tempoCacheConsulta,
      logradouro:data.logradouro,
      numeroEndereco:data.numeroEndereco,
      complemento:data.complemento,
      bairro:data.bairro,
      cidade:data.cidade,
      uf:data.uf,
      dataCadastro:data.dataCadastro,
      dataContratacao:data.dataContratacao,
      diaVencimentoFatura:data.diaVencimentoFatura,
      vcm:data.vcm === 0 ? null : data.vcm,
      limitarValorMaximo:limitarValorMaximo,
      valorMaximo:limitarValorMaximo ? data.valorMaximo : null,
      cnae:data.cnae,
      segmentoCnae: selectedSegmentoCnae,
      enviarParaQuod: enviarParaQuod,
      idFranquia: selectedFranquia?.id
    }
    window.scrollTo(0, 0);
    onSave(cliente);
  }

  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const buscarCep = (cep: string) => {
    if (cep.length === 8) {
      getViaCep(cep).then((data) => {
        if (data && !data.erro) {
          setValue('logradouro', data.logradouro)
          setValue('bairro', data.bairro)
          setValue('cidade', data.localidade)
          setValue('uf', data.uf)
        }
        else {
          msgs.current?.show({
            sticky: false,
            life: 10000,
            severity: 'error',
            summary: 'Erro',
            detail: 'CEP não encontrado',
            closable: false
          });
        }
      }).catch((erro) => console.log(erro))
    }
  };

  useEffect(() => {
    const lazyFranquia = {
        first: 0,
        rows: 9999,
        page: 1,
        franquia: null,
        documento: null,
        sortField: 'nome',
        sortOrder: SortOrder.DESC
      };

      findFranquia(lazyFranquia).then(data => {
        data.franquias.forEach( (c: { nome: string; id: string; }) => {
          if(client.id && client.idFranquia && c.nome == client.nomeFranquia){
            setSelectedFranquia(c)
          }

          if(state.user.franquiaSelected && c.nome == state.user.franquiaSelected.nome){
            setSelectedFranquia(c)
          }
        })
        setFranquias(data.franquias);
      })
    const lazyPlano = {
        first: 0,
        rows: 99999999,
        page: 1,
        descricao: null,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        ativo: true,
        sortField: 'descricao',
        sortOrder: SortOrder.DESC
      }
      findPlano(lazyPlano).then((data) => {
        setPlanos(data.planos);
        if(client.idPlano){
            setValue('plano',data.planos.filter((s:any) => s.descricao === client.nomePlano)[0]);
            setPlanoSelected(data.planos.filter((s:any) => s.descricao === client.nomePlano)[0]);
        }
      });

  },[])

  const nextStep = () => {
    if (activeIndex < 2) {
      if (validateCurrentStep()) {
        setActiveIndex(activeIndex + 1);
      }
    }
  };

  const prevStep = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const getFieldLabel = (fieldName: string) => {
    const labels: { [key: string]: string } = {
      'nome': 'Razão Social',
      'documento': 'CNPJ',
      'email': 'E-mail',
      'plano': 'Plano'
    };
    return labels[fieldName] || fieldName;
  };

  const validateCurrentStep = () => {
    const formValues = control._formValues;

    switch (activeIndex) {
      case 0: // Dados do cliente
        const requiredDadosFields = ['nome', 'documento', 'email'];
        for (const field of requiredDadosFields) {
          if (!formValues[field] || formValues[field].trim() === '') {
            msgs.current?.clear();
            msgs.current?.show([
              {
                sticky: false,
                life: 5000,
                severity: 'warn',
                summary: 'Campos obrigatórios',
                detail: `Por favor, preencha todos os campos obrigatórios: ${requiredDadosFields.map(f => getFieldLabel(f)).join(', ')}`,
                closable: true
              }
            ]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }

        // Validar documento
        if (formValues.documento) {
          const docValid = formValues.documento.length === 14 ?
            isValidCPF(formValues.documento) :
            isValidCNPJ(formValues.documento);
          if (!docValid) {
            msgs.current?.clear();
            msgs.current?.show([
              {
                sticky: false,
                life: 5000,
                severity: 'error',
                summary: 'Documento inválido',
                detail: 'Por favor, insira um documento válido',
                closable: true
              }
            ]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }

        // Validar e-mail
        if (formValues.email && !isValidMultiEmail(formValues.email)) {
          msgs.current?.clear();
          msgs.current?.show([
            {
              sticky: false,
              life: 5000,
              severity: 'error',
              summary: 'E-mail inválido',
              detail: 'Por favor, insira um e-mail válido. Para mais de um, separe-os com ponto e vírgula (;)',
              closable: true
            }
          ]);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        return true;

      case 1: // Configurações
        // Para o step de configurações, não há campos obrigatórios específicos
        return true;

      case 2: // Faturamento
        const requiredFaturamentoFields = ['plano'];
        for (const field of requiredFaturamentoFields) {
          if (!formValues[field]) {
            msgs.current?.clear();
            msgs.current?.show([
              {
                sticky: false,
                life: 5000,
                severity: 'warn',
                summary: 'Campos obrigatórios',
                detail: `Por favor, preencha todos os campos obrigatórios: ${requiredFaturamentoFields.map(f => getFieldLabel(f)).join(', ')}`,
                closable: true
              }
            ]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }
        return true;

      default:
        return true;
    }
  };

  const renderDadosStep = () => (
    <div>
      {/* Dados do Cliente */}
      <div className="mb-4">
        <h4 className="font-semibold mb-3 border-bottom pb-2" style={{ color: '#4b5563', fontSize: '1.25rem' }}>Informações do Cliente</h4>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="nome"
              control={control}
              rules={{ required: 'Nome é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.nome })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="nome" className="font-bold block mb-2 required">{t('razaoSocial')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="documento"
              control={control}
              rules={{ required: 'Documento é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.documento })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="documento" className="font-bold block mb-2 required">{t('cnpj')} </label>
                      <InputText
                        maxLength={18}
                        min={18}
                        max={18}
                        onKeyUp={() => { field.onChange(maskCNPJ(field.value))}}
                        style={{width:'100%'}}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onBlur={(e) => validDocument(e.target.value)}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          if (clienteJaCadastrado) setClienteJaCadastrado(false);
                        }}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="codigoClienteErp"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.codigoClienteErp })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="codigoCliente" className="font-bold block mb-2">{t('codigoCliente')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="nomeFantasia"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.nomeFantasia })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="nomeFantasia" className="font-bold block mb-2">{t('nomeFantasia')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col">
            <Controller
              name="responsavel"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.responsavel })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="responsavel" className="font-bold block mb-2">{t('responsavel')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="cnae"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.cnae })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="cnae" className="font-bold block mb-2">{t('cnae')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <div>
              <label className="font-bold block mb-2">{t('segmentoCnae')} </label>
              <Dropdown style={{ width: '100%' }} value={selectedSegmentoCnae} onChange={(e) => setSelectedSegmentoCnae(e.value)} options={segmentosCnae} optionLabel="name"
                optionValue="code" placeholder="Selecione" className="w-full md:w-14rem" />
            </div>
          </div>
        </div>
        {((getValues('documento') || '').replace(/\D/g, '').length === 14 && !client.possuiClienteIndiretoQuod) && (
          <div className="grid">
            <div className="col">
              <div>
                <label className="label-dados" style={{ paddingLeft: '0' }}>{t('enviarParaQuod')}</label>
                <div style={{ width: '100%' }}>
                  <InputSwitch checked={enviarParaQuod} onChange={() => setEnviarParaQuod(!enviarParaQuod)} />
                </div>
                <small className="block text-color-secondary mt-1">Cadastra o cliente como cliente indireto na Quod (apenas CNPJ). Se o envio falhar, o cliente não será salvo.</small>
              </div>
            </div>
          </div>
        )}
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="dataCadastro"
              control={control}
              render={({ field }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataCadastro })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="dataCadastro" className="font-bold block mb-2">{t('dataCadastro')} </label>
                      <Calendar id='dataCadastro' value={field.value || null} onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="dataContratacao"
              control={control}
              render={({ field }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataContratacao })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="dataContratacao" className="font-bold block mb-2">{t('dataContratacao')} </label>
                      <Calendar id='dataContratacao' value={field.value || null} onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          {!state.user.franquia && (
            <div className="col p-fluid flex flex-wrap">
              <div>
                <label className="font-bold block mb-2">{t('franquia')}</label>
                <Dropdown disabled={state.user.franquiaSelected} style={{width: '100%'}} value={selectedFranquia} onChange={(e) => setSelectedFranquia(e.value)} options={franquias} optionLabel="nome"
                  placeholder="Selecione" className="w-full md:w-14rem" />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Contatos */}
      <div className="mb-4">
        <h4 className="font-semibold mb-3 border-bottom pb-2" style={{ color: '#4b5563', fontWeight: 800, fontSize: '1.25rem' }}>Contatos</h4>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="email"
              control={control}
              rules={{
                required: 'Email é Obrigatório',
                validate: (value) => isValidMultiEmail(value) || 'E-mail inválido'
              }}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.email })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="email" className="font-bold block mb-2 required">{t('email')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                      <small className="block text-color-secondary mt-1">Para informar mais de um e-mail, separe-os com ponto e vírgula (;)</small>
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="telefone"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.telefone })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="telefone" className="font-bold block mb-2">{t('fone')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="whatsapp"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.whatsapp })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="whatsapp" className="font-bold block mb-2">{t('whatsapp')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
      </div>

      {/* Endereço */}
      <div className="mb-4">
        <h4 className="font-semibold mb-3 border-bottom pb-2" style={{ color: '#4b5563', fontWeight: 800, fontSize: '1.25rem' }}>Endereço</h4>
        <div className="grid">
          <div className="col">
            <Controller
              name="cep"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.cep })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="cep" className="font-bold block mb-2">{t('cep')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          buscarCep(e.target.value);
                        }}
                        onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) {e.preventDefault();}}}
                        maxLength={8}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="logradouro"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.logradouro })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="logradouro" className="font-bold block mb-2">{t('logradouro')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="numeroEndereco"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.numeroEndereco })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="numero" className="font-bold block mb-2">{t('numero')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="bairro"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.bairro })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="bairro" className="font-bold block mb-2">{t('bairro')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="complemento"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.complemento })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="complemento" className="font-bold block mb-2">{t('complemento')} </label>
                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="cidade"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.cidade })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="cidade" className="font-bold block mb-2">{t('cidade')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        disabled={true}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="uf"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.uf })}></label>
                  <span className="">
                    <div>
                      <label htmlFor="uf" className="font-bold block mb-2">{t('uf')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        disabled={true}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
      </div>

      {/* Observações */}
      <div className="grid">
        <div className="col">
          <Controller
            name="observacoes"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <label htmlFor={field.name} className={classNames({ 'p-error': errors.observacoes })}></label>
                <span className="">
                  <div>
                    <label htmlFor="observacoes" className="font-bold block mb-2">{t('observacoes')} </label>
                    <InputTextarea style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                  </div>
                </span>
                {getFormErrorMessage(field.name)}
              </>
            )}
          />
        </div>
      </div>
    </div>
  );

  const renderConfiguracoesStep = () => (
    <div>
      <div className="grid">
        <div className="col">
          <Controller
            name="tempoCacheConsulta"
            control={control}
            render={({ field }) => (
              <>
                <label htmlFor={field.name} className={classNames({ 'p-error': errors.tempoCacheConsulta })}></label>
                <span className="">
                  <div>
                    <label htmlFor="tempoCacheConsulta" className="font-bold block mb-2">{t('tempoCacheConsulta')} </label>
                    <InputNumber value={field.value} onChange={(e) => field.onChange(e.value)} useGrouping={false} />
                  </div>
                </span>
                {getFormErrorMessage(field.name)}
              </>
            )}
          />
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados" style={{paddingLeft:'0'}}>{t('separarResposta')}</label>
            <div style={{width:'100%' , marginTop:'0.5rem'}}>
              <InputSwitch checked={separarResposta} value={separarResposta} onChange={() => setSepararResposta(!separarResposta)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderFaturamentoStep = () => (
    <div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div className="grid">
            <div className="col">
              <Controller
                name="plano"
                control={control}
                rules={{ required: 'Plano é Obrigatório' }}
                render={({ field }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.plano })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="plano" className="font-bold block mb-2 required">{t('plano')} </label>
                        <Dropdown
                          style={{width: '100%'}}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                            setPlanoSelected(e.value);
                          }}
                          options={planos}
                          optionLabel="descricao"
                          placeholder="Selecione Plano"
                          filter
                          className="md:w-14rem"
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col" style={{display: 'inline-grid'}}>
              {state.user.funcoes.includes("PLANO_CADASTRAR") && planoSelected && (<Button type="button" style={{width: '12rem', color:'#183462'}} onClick={()=>editarPlano()} icon="pi pi-pen-to-square" label="Editar Plano" text />)}
              {state.user.funcoes.includes("PLANO_CADASTRAR") && client.id && client.idPlano && planoSelected && !planoSelected.idOrigem && (<Button type="button" style={{width: '12rem', color:'#183462'}} onClick={()=>customizarPlano()} icon="pi pi-clone" label="Customizar Plano" text />)}
              {state.user.funcoes.includes("PLANO_CADASTRAR") && client.id && client.idPlano && planoSelected && planoSelected.idOrigem && (<Button type="button" style={{width: '12rem', color:'#183462'}} onClick={()=>restaurarPlanoCustomizado()} icon="pi pi-directions-alt" label="Restaurar Plano" text />)}
            </div>
          </div>
        </div>
      </div>

      <div className="grid">
        <div className="col">
          <Controller
            name="vcm"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <label htmlFor={field.name} className={classNames({ 'p-error': errors.vcm })}></label>
                <span className="">
                  <div>
                    <label htmlFor={field.name} className="font-bold block mb-2">{t('vcm')} </label>
                    <InputNumber
                      style={{ width: '100%' }}
                      id={field.name}
                      value={field.value}
                      className={classNames({ 'p-invalid': fieldState.error })}
                      onValueChange={(e) => field.onChange(e.value)}
                      mode="currency"
                      currency="BRL"
                      locale="pt-BR"
                    />
                  </div>
                </span>
                {getFormErrorMessage(field.name)}
              </>
            )}
          />
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados" style={{ paddingLeft: '0' }}>{t('limitarValorMaximo')}</label>
            <div style={{ width: '100%' }}>
              <InputSwitch checked={limitarValorMaximo} value={limitarValorMaximo} onChange={() => setLimitarValorMaximo(!limitarValorMaximo)} />
            </div>
          </div>
        </div>
        {limitarValorMaximo && (
          <div className="col">
            <Controller
              name="valorMaximo"
              control={control}
              rules={{ validate: (value) => (value && value > 0) || 'Valor Máximo é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.valorMaximo })}></label>
                  <span className="">
                    <div>
                      <label htmlFor={field.name} className="font-bold block mb-2 required">{t('valorMaximo')} </label>
                      <InputNumber
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onValueChange={(e) => field.onChange(e.value)}
                        mode="currency"
                        currency="BRL"
                        locale="pt-BR"
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        )}
      </div>

      <div className="grid">
        <div className="col">
          <Controller
            name="diaVencimentoFatura"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <label htmlFor={field.name} className={classNames({ 'p-error': errors.diaVencimentoFatura })}></label>
                <span className="">
                  <div>
                    <label htmlFor="diaVencimentoFatura" className="font-bold block mb-2">{t('diaVencimentoFatura')} </label>
                    <InputText maxLength={2} style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) {e.preventDefault();}}} />
                  </div>
                </span>
                {getFormErrorMessage(field.name)}
              </>
            )}
          />
        </div>
      </div>
    </div>
  );

  const renderStepContent = () => {
    switch (activeIndex) {
      case 0:
        return renderDadosStep();
      case 1:
        return renderConfiguracoesStep();
      case 2:
        return renderFaturamentoStep();
      default:
        return renderDadosStep();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
      <div className="card">
        <Steps model={items} activeIndex={activeIndex} />
      </div>

      <div className="card">
        {renderStepContent()}
      </div>

      <br></br>
      <br></br>
      <div style={{display:"flex", justifyContent:"space-between", paddingTop:"1rem"}} className=" flex">
        <div>
          {activeIndex > 0 && (
            <Button
              type="button"
              label="Anterior"
              icon="pi pi-chevron-left"
              onClick={prevStep}
              style={{ marginRight: "1rem", backgroundColor: 'white', color: '#183462', borderColor: '#183462' }}
            />
          )}
        </div>
        <div className="flex-consulta" style={{ gap: '0.5rem' }}>
          <Button type="button" label="Fechar" severity="secondary" outlined onClick={onClose} />
          {activeIndex === 2 && (
            <Button style={{ marginRight: "1rem", backgroundColor: '#183462', borderColor: '#183462' }} label="Salvar" type="submit" disabled={clienteJaCadastrado} />
          )}
          {activeIndex < 2 && (
            <Button
              type="button"
              label="Próximo"
              icon="pi pi-chevron-right"
              iconPos="right"
              onClick={nextStep}
              disabled={clienteJaCadastrado}
              style={{ backgroundColor: '#183462', borderColor: '#183462' }}
            />
          )}
        </div>
      </div>
    </form>
  )
}
